module.exports = __webpack_public_path__ + "static/media/lc100_1.2f34b5a4.png";